var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProfileAndCourses',{attrs:{"teacher-id":_vm.teacherId}})
}
var staticRenderFns = []

export { render, staticRenderFns }